import React from 'react'
import { DivContentBox } from '../common/styled'

export const getScore = (data = []) => {
  let score = null
  if (data) {
    let scores = []
    data.map((source) =>
      scores.push(parseInt(source.score && source.data_provider.data_provider_type.id === 2 ? source.score : 0, 10))
    )
    scores.sort((a, b) => b - a)
    if (scores.length > 0) {
      score = scores[0]
    }
  }

  return score
}

const FaceMatchScore = ({ data }) => (
  <div>
    <div className='ibox-title'>
      <h5>Face Match Score</h5>
    </div>
    <DivContentBox className='ibox-content text-center text-uppercase'>
      <span className='bg-success p-xs' style={{ cursor: 'default', fontSize: '14px' }}>
        {getScore(data) || 'N/A'}
      </span>
    </DivContentBox>
  </div>
)

export default FaceMatchScore
